// extracted by mini-css-extract-plugin
export default {"noneRender":"DigitalWalletTokensTable_noneRender__DQTEY"};